import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutationVariables = Types.Exact<{
  input: Types.AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareInput;
}>;


export type AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutation = { __typename?: 'Mutation', assignRegulatoryDocumentParagraphsRequirementsDocumentCompare: { __typename?: 'AssignRegulatoryDocumentParagraphsRequirementsDocumentComparePayload', regulatoryDocument?: { __typename?: 'RegulatoryDocument', id: string } | null } };


export const AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareDocument = gql`
    mutation AssignRegulatoryDocumentParagraphsRequirementsDocumentCompare($input: AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareInput!) {
  assignRegulatoryDocumentParagraphsRequirementsDocumentCompare(input: $input) {
    regulatoryDocument {
      id
    }
  }
}
    `;
export type AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutationFn = Apollo.MutationFunction<AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutation, AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutationVariables>;

/**
 * __useAssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutation__
 *
 * To run a mutation, you first call `useAssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutation, { data, loading, error }] = useAssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutation(baseOptions?: Apollo.MutationHookOptions<AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutation, AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutation, AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutationVariables>(AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareDocument, options);
      }
export type AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutationHookResult = ReturnType<typeof useAssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutation>;
export type AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutationResult = Apollo.MutationResult<AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutation>;
export type AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutationOptions = Apollo.BaseMutationOptions<AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutation, AssignRegulatoryDocumentParagraphsRequirementsDocumentCompareMutationVariables>;